/*
 * useMonetateData - this hook prepares analytics data and makes Load-Ready or VirtualPage-View calls
 */

import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getLoggedUserMail, getItemDiscountedTotalPrice, getItemTotalPrice, getInsuranceBenefits, getDiscountNames, getDiscoutCodes, getInsuranceCode, convertNumber} from '@utils/utils';


const useMonetate = (page: string, elementToWatch) => {

    const formattedOrderItems = useSelector(state => state.cart.formattedOrderItems);
    const isLoaded = useSelector(state => state.cart.isLoaded);
    const [dataToPush, setDataToPush] = useState(null);
    
    const getPageSections = (page) => {
        switch(page) {
            case 'Cart':
                window.cartPageType = "cart";
                return ["setPageType","cart"];
            case 'Shipping':
                window.cartPageType = "shipping_billing_checkout";
                return ["setPageType","shipping_billing_checkout"];
            case 'Payment': 
                window.cartPageType = "payment_checkout";
                return ["setPageType","payment_checkout"];
            case 'Thankyou':
                window.cartPageType = "purchase";
                return ["setPageType","purchase"];
        }
    }

    const getItemsCart = (page,items) => {
        switch(page) {
            case 'Cart':
                return ["addCartRows",getProducts(items)];
            case 'Shipping':
                return ["addCartRows",getProducts(items)];
            case 'Payment': 
                return ["addCartRows",getProducts(items)];
            case 'Thankyou':
                return ["addPurchaseRows",getOrderDetails(elementToWatch,items)];
        }
    }

    const getOrderDetails = (order,items) => {
        if(items.length === 0) {
            return {}
        } 
        
        let partNumberUsed = [];
        const obj = {};
        items.map(item => {
            let productsPartNumber;
            if(partNumberUsed.find(p => item.frame.partNumber === p.partNumber) === undefined) {
                productsPartNumber = item.frame.partNumber;
                partNumberUsed.push({
                    partNumber: item.frame.partNumber,
                    count: 1
                })
            } else {
                const index = partNumberUsed.findIndex(p => item.frame.partNumber === p.partNumber);
                productsPartNumber = item.frame.partNumber + '#' + partNumberUsed[index].count;
                partNumberUsed[index].count = partNumberUsed[index].count + 1; 
            }
            
            obj[productsPartNumber] = {
                "purchaseId": order.orderId,
                "productId": !!item.partNumber_frame ? item.partNumber_frame.replace('_SKU', '') :  '',
                "quantity": "1",
                "unitPrice":  item.frame.finalDiscountPrice,
                "currency": 'USD',
                "prodId" : item.frame.productId,
            }

            obj[productsPartNumber + '_lenses'] = {
                "purchaseId": order.orderId,
                "productId": !!item.partNumber_lenses ? item.partNumber_lenses.replace('_SKU', '') :  '',
                "quantity": '1',
                "unitPrice": item.lenses.finalDiscountPrice,
                "currency": 'USD',
                "prodId" : item.lenses.productId,
            }

        });

        window.purchaseProducts = Object.values(obj);

        return Object.values(obj);
    }

    //getProducts - this function get all the products for populate 'Products' object in data object
    const getProducts = (items) => {
        if(items.length === 0) {
            return {}
        } 
        
        let partNumberUsed = [];
        const obj = {};
        items.map(item => {
            let productsPartNumber;
            if(partNumberUsed.find(p => item.frame.partNumber === p.partNumber) === undefined) {
                productsPartNumber = item.frame.partNumber;
                partNumberUsed.push({
                    partNumber: item.frame.partNumber,
                    count: 1
                })
            } else {
                const index = partNumberUsed.findIndex(p => item.frame.partNumber === p.partNumber);
                productsPartNumber = item.frame.partNumber + '#' + partNumberUsed[index].count;
                partNumberUsed[index].count = partNumberUsed[index].count + 1; 
            }
            
            obj[productsPartNumber] = {
                "productId": !!item.partNumber_frame ? item.partNumber_frame.replace('_SKU', '') :  '',
                "quantity": '1',
                "unitPrice": item.frame.finalDiscountPrice,
                "sku": !!item.partNumber_frame ? item.partNumber_frame.replace('_SKU', '') :  '',
                "currency": 'USD'
            }

            obj[productsPartNumber + '_lenses'] = {
                "productId": !!item.partNumber_lenses ? item.partNumber_lenses.replace('_SKU', '') :  '',
                "quantity": '1',
                "unitPrice": item.lenses.finalDiscountPrice,
                "sku": !!item.partNumber_lenses ? item.partNumber_lenses.replace('_SKU', '') :  '',
                "currency": 'USD'
            }

        });
        return Object.values(obj);
    }

    /*
      This hook is called every time dataToPush changes and makes Loading-Ready/VirtualPage-View
      calls based on the different pages    
    */
      useEffect(() => {
        if(dataToPush !== null) {
            let pagetopush;
            let itemtopush;
            window.monetateQ = window.monetateQ || [];
            try {
                pagetopush= dataToPush["page"];
                itemtopush= dataToPush["items"];
                var url = document.referrer;
                if (url.includes("rxcnav")){
		                var parts = url.split('/');
		                var breadcrumb = parts.toString().split('gl-us')[1];               
		                var brand = breadcrumb.split(',')[1];
		                var total_upc = breadcrumb.split(',')[2];
		                var upc=total_upc.split('?')[0];
		                switch(page) {
				            case 'Cart':
                                window.cartBreadcrumbs = ["Home",brand,upc,"Cart"];
                                window.monetateQ?.push([
                                    "addBreadcrumbs", ["Home",brand,upc,"Cart"]
                                  ]); 
								break;
				            case 'Shipping':
                                window.cartBreadcrumbs =  ["Home",brand,upc,"Cart","Shipping"];
                                window.monetateQ?.push([
                                    "addBreadcrumbs", ["Home",brand,upc,"Cart","Shipping"]
                                  ]);
								break;
				            case 'Payment': 
                                window.cartBreadcrumbs = ["Home",brand,upc,"Cart","Shipping","Payment"];
                                window.monetateQ?.push([
                                    "addBreadcrumbs", ["Home",brand,upc,"Cart","Shipping","Payment"]
                                  ]);
								break;
				            case 'Thankyou':				               
                                window.cartBreadcrumbs = ["Home",brand,upc,"Cart","Shipping","Payment","Thankyou"];
                                window.monetateQ?.push([
                                    "addBreadcrumbs", ["Home",brand,upc,"Cart","Shipping","Payment","Thankyou"]
                                  ]);
				        }	
            }else{
	            	formattedOrderItems.map((item) => {
	                if (item.frame.category=="EYE"){
	                switch(page) {
			            case 'Cart':
                            window.cartBreadcrumbs = ["Home", "Eyeglasses",item.frame.partNumber,"Cart"];
                            window.monetateQ?.push([
                                "addBreadcrumbs", ["Home", "Eyeglasses",item.frame.partNumber,"Cart"]
                              ]);
							break;
			            case 'Shipping':
                            window.cartBreadcrumbs = ["Home", "Eyeglasses",item.frame.partNumber,"Cart","Shipping"];
                            window.monetateQ?.push([
                                "addBreadcrumbs", ["Home", "Eyeglasses",item.frame.partNumber,"Cart","Shipping"]
                              ]);
							break;
			            case 'Payment': 
                            window.cartBreadcrumbs = ["Home", "Eyeglasses",item.frame.partNumber,"Cart","Shipping","Payment"];
                            window.monetateQ?.push([
                                "addBreadcrumbs", ["Home", "Eyeglasses",item.frame.partNumber,"Cart","Shipping","Payment"]
                              ]);
							break;
			            case 'Thankyou':
                            window.cartBreadcrumbs = ["Home", "Eyeglasses",item.frame.partNumber,"Cart","Shipping","Payment","Thankyou"];
                            window.monetateQ?.push([
                                "addBreadcrumbs", ["Home", "Eyeglasses",item.frame.partNumber,"Cart","Shipping","Payment","Thankyou"]
                              ]);
			        }
	                } else if (item.frame.category=="SUN"){
					switch(page) {
			            case 'Cart':
                            window.cartBreadcrumbs = ["HOME", "SUNGLASSES",item.frame.partNumber,"Cart"];
                            window.monetateQ?.push([
                                "addBreadcrumbs", ["HOME", "SUNGLASSES",item.frame.partNumber,"Cart"]
                              ]);
							break;
			            case 'Shipping':
                            window.cartBreadcrumbs = ["HOME", "SUNGLASSES",item.frame.partNumber,"Cart","Shipping"];
                            window.monetateQ?.push([
                                "addBreadcrumbs", ["HOME", "SUNGLASSES",item.frame.partNumber,"Cart","Shipping"]
                              ]);
							break;
			            case 'Payment': 
                            window.cartBreadcrumbs = ["HOME", "SUNGLASSES",item.frame.partNumber,"Cart","Shipping","Payment"];
                            window.monetateQ?.push([
                                "addBreadcrumbs", ["HOME", "SUNGLASSES",item.frame.partNumber,"Cart","Shipping","Payment"]
                              ]);
							break;
			            case 'Thankyou': 
                            window.cartBreadcrumbs = ["HOME", "SUNGLASSES",item.frame.partNumber,"Cart","Shipping","Payment","Thankyou"];
                            window.monetateQ?.push([
                                "addBreadcrumbs", ["HOME", "SUNGLASSES",item.frame.partNumber,"Cart","Shipping","Payment","Thankyou"]
                              ]);
			        }
					}
	                });
            }
            } catch(err) {
                console.log('>>> Error in getting cart information about page and items');
            } finally {
                window?.monetateQ?.push(pagetopush);
                window?.monetateQ?.push(itemtopush);
                				
                window?.monetateQ?.push(["trackData"]);
                setDataToPush(null);
            }    
        }
    }, [dataToPush]);


    useEffect(() => {
        if(isLoaded === true) {
            if(dataToPush === null) {
                let obj = {};
                try {
                    obj = {
                            page:getPageSections(page),
                            items: getItemsCart(page,formattedOrderItems)
                          } 
                } catch(err) {
                    console.log('>>> Error in getting cart information about page and items');
                } 
                finally {
                    setDataToPush(obj);
                }    
            }
        }
    }, [page, isLoaded, formattedOrderItems]);
}
export default useMonetate;